import {Component, OnInit} from '@angular/core';
import {Validators, FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {UserService} from 'src/app/service/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: any;
  fieldTextType: any;
  isLoading: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService) {
    this.loginForm = this.formBuilder.group({
      user: ["", [Validators.required]],
      password: ["", Validators.required]
    });
  }

  ngOnInit() {
  }

  toggleFieldTextType() {

  }

  login() {
    this.isLoading = true;
    let request = {
      username: this.loginForm.controls.user.value,
      password: this.loginForm.controls.password.value,
    }
    this.userService.login(request).subscribe(
      res => {
        if(res.responseCode == 200){
          console.log(res);
          localStorage.setItem('user',JSON.stringify(res.data));
          this.isLoading = false;
          this.route.navigate(['/select']);
        }else {
          this.notifier.notify( 'danger', res.responseDesc );
          this.isLoading =false;
        }
        }
      )
  }
}
